export enum StepName {
  Initial = 'Initial',
  ClientType = 'ClientType',
  MainCareer = 'Career',
  Welcome = 'Welcome',
  Location = 'Location',
  Acquaintance = 'Acquaintance',
  Tariff = 'Tariff',
  AfterAll = 'AfterAll',
}
